<template>
	<div class="home">
		<div class="container">
			<div class="row">
				<div class="col-12 p-md-0">
					<div class="col-12 pt-3 pb-3 p-md-3 rounded background-white top-slider shadow d-md-flex">
						<div class="offset-2 col-8 justify-content-center offset-md-0 col-md-3">
							<img class="img-fluid" src="assets/digitial-imaging-product-milagros.png" alt="">
						</div>
						<div class="col-12 col-md-9 p-0 p-md-3 font-size-sm-10">
							<div class="col-12">
								<h2 class="color-black">Manfaat Milagros</h2>
							</div>
							<div class="col-12 pr-0 height-paragraph-2 text-justify color-black">
								Milagros adalah air minum dalam kemasan yang alami. Mengingat air adalah kebutuhan dasar manusia, maka dapatlah dikatakan bahwa Milagros adalah kebutuhan dan bukanlah suplemen.
							</div>
							<div class="col-12 mt-3 pt-0 d-flex justify-content-between justify-content-md-start">
								<button class="btn pl-3 pr-3 rounded background-button-template  no-box-shadow color-white font-size-11" @click="lihatManfaat">
									<span class="font-size-10 font-size-sm-9">Lihat Selengkapnya</span>
								</button>
							</div>
						</div>
					</div>
					<div class="col-12 mt-3 mb-3 pl-0 pr-0 pl-md-3 pr-md-3">
						<div class="col-12 p-0 d-lg-flex ml-n2 ml-md-0">
							<div class="col-12 col-md-12 col-lg-6 p-0 d-flex">
								<div class="col-6 p-0 p-md-3 justify-content-center d-flex">
									<div class="col-5 offset-md-0 col-md-4 pt-3">
										<img class="img-fluid" src="assets/icon/ic_support.png" alt="">
									</div>
									<div class="col-7 col-md-8 p-0 pt-2">
										<div class="col-12 p-0 font-size-15 font-size-sm-9 color-mila"><b>Layanan <span class="f-lato">24/7</span></b></div>
										<div class="col-12 p-0 font-size-11 font-size-sm-7 color-gray">Tim  Support Handal dan Cepat untuk Anda</div>
									</div>
								</div>
								<div class="col-6 p-0 p-md-3 justify-content-center d-flex">
									<div class="col-5 offset-md-0 col-md-4 pt-3">
										<img class="img-fluid" src="assets/icon/ic_delivery.png" alt="">
									</div>
									<div class="col-7 col-md-8 p-0 pt-2">
										<div class="col-12 p-0 font-size-15 font-size-sm-9 color-mila"><b>Layanan Cepat</b></div>
										<div class="col-12 p-0 font-size-11 font-size-sm-7 color-gray">Pemesanan dan Pengiriman dalam 1 hari</div>
									</div>
								</div>
							</div>
							<div class="col-12 col-md-12 col-lg-6 p-0 mt-3 mt-md-0 d-flex">
								<div class="col-6 p-0 p-md-3 justify-content-center d-flex">
									<div class="col-5 offset-md-0 col-md-4 pt-3">
										<img class="img-fluid" src="assets/icon/ic_security.png" alt="">
									</div>
									<div class="col-7 col-md-8 p-0 pt-2">
										<div class="col-12 p-0 font-size-15 font-size-sm-9 color-mila"><b>Transaksi Aman</b></div>
										<div class="col-12 p-0 font-size-11 font-size-sm-7 color-gray">Jaminan Keamanan dalam Bertransaksi</div>
									</div>
								</div>
								<div class="col-6 p-0 p-md-3 justify-content-center d-flex">
									<div class="col-5 offset-md-0 col-md-4 pt-3">
										<img class="img-fluid" src="assets/icon/ic_guaranty.png" alt="">
									</div>
									<div class="col-7 col-md-8 p-0 pt-2">
										<div class="col-12 p-0 font-size-15 font-size-sm-9 color-mila"><b>Garansi Milagros</b></div>
										<div class="col-12 p-0 font-size-11 font-size-sm-7 color-gray">100% Produk ASLI Milagros</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-12 text-center color-black font-size-sm-15 font-size-22 font-weight-bold pt-3 pb-3 text-uppercase">
						Produk milagros
					</div>
					<div class="col-12 pl-0 pr-0 pt-md-3 pb-3" >
						<carousel v-if="Object.keys(allProduct).length > 0" ref="carousel" id="owl-menu" class="col-12 pl-0 pr-0 pt-2 pb-2" :responsive="{0:{items:1},600:{items:2},1000:{items:3}}" :margin="20" :autoplay="true" :nav="false" :loop="false" :dots="true">
							<div class="col-12 background-white rounded hov-cus-shadow pt-3 pb-3 mb-2 mr-2" v-for="(product, index) in allProduct" :key="index">
								<div class="col-12 d-flex pl-0 pr-0 box-product">
									<div class="col-6 pl-0 text-center">
										<img :src="product.product_image_filename" class="img-fluid rounded img-thumb-stockist" style="height: 150px; width: auto; display: inline;" alt="">
									</div>
									<div class="col-6 pl-0 pr-0">
										<div class="color-mila font-weight-bold font-size-sm-11 font-size-12">{{ product.product_name }}</div>
										<div class="color-purple font-size-sm-10 font-size-12 f-lato">Rp {{ product.product_price | toNumber }} / {{ product.product_unit }}</div>
										<div class="color-gray font-size-10 f-lato">{{ product.product_weight | toKg }}</div>
										<div class="color-black font-size-sm-9 font-size-10 pt-2">{{ product.product_description.slice(0, 60) }}...</div>
									</div>
								</div>
								<div class="col-12 mt-3 pl-0 pr-0 pt-0">
									<router-link :to="{ name: 'product', params: { code: product.product_code }}" class="col-12 btn rounded background-button-template no-box-shadow color-white">
										<span class="font-size-11">Detail Produk</span>
									</router-link>
								</div>
							</div>
						</carousel>
						<carousel v-show="Object.keys(allProduct).length == 0" ref="carousel3" id="owl-menu3" class="col-12 pl-0 pr-0 pt-2 pb-2" :responsive="{0:{items:1},600:{items:2},1000:{items:3}}" :margin="20" :autoplay="true" :nav="false" :loop="false" :dots="true">
							<SkeletonProduct class="col-12 background-white rounded hov-cus-shadow pt-3 pb-3 mb-2 mr-2" v-for="index in 3" :key="'skl-product'+index"/>
						</carousel>
					</div>
					<div class="col-12 text-center color-black font-size-sm-15 font-size-22 font-weight-bold pt-3 pb-4 text-uppercase">
						Mobile counter
					</div>
					<div class="col-12 p-0 p-lg-3 pb-3 mt-lg-2 d-lg-flex background-white cus-box-shadow rounded">
						<div class="col-12 col-lg-2 d-lg-flex p-0 pt-2 pl-lg-0 pt-lg-3 pb-lg-3" v-if="false">
							<div class="col-12 col-lg-4 pr-0 pt-3 pt-lg-1 font-size-sm-11 d-none d-lg-block" v-if="false">
								<img src="/assets/icon/filter.svg" alt="" class="img-fluid pr-2">Filter
							</div>
							<div class="col-12 col-lg-12 pt-2 pt-lg-0 pl-lg-0">
								<input type="text" v-model="kode.value" class="form-control form-control-sm box-purple" placeholder="Nama / Kode" @keyup.enter="cari()">
							</div>
						</div>
						<!-- awalnya 10 tapi karena nama/kode mb di remove, makanya jadi 12 -->
						<!-- <div class="col-12 col-lg-10 d-lg-flex p-0 pl-lg-0 pt-lg-3"> -->
						<div class="col-12 col-lg-12 d-lg-flex p-0 pl-lg-0 pt-lg-3">
							<div class="col-12 col-lg-4 pl-lg-0 pr-lg-0 pr-lg-4 pt-2 pt-lg-0">
								<v-select label="province" class="font-size-10" :reduce="provinces => provinces.province_id" :options="provinceList" v-model="provinsi.value" placeholder="Pilih Provinsi" @input="searchCity">
									<template v-slot:no-options="{ search, searching }">
										<template v-if="searching">
											Tidak ada kata yang cocok untuk <em>{{ search }}</em>.
										</template>
										<em style="opacity: 0.5;" v-else>Ketik untuk mencari Provinsi</em>
									</template>
								</v-select>
							</div>
							<div class="col-12 col-lg-4 pl-lg-0 pr-lg-0 pr-lg-4 pt-2 pt-lg-0">
								<v-select label="city_type_name" class="font-size-10" :reduce="city => city.city_id" :options="cityList" v-model="kota.value" placeholder="Pilih Kota"  @input="searchDistrict">
									<template v-slot:no-options="{ search, searching }">
										<template v-if="searching">
											Tidak ada kata yang cocok untuk <em>{{ search }}</em>.
										</template>
										<em style="opacity: 0.5;" v-else>Ketik untuk mencari Kota</em>
									</template>
								</v-select>
							</div>
							<div class="col-12 col-lg-3 pl-lg-0 pr-lg-0 pr-lg-4 pt-2 pt-lg-0">
								<v-select label="subdistrict_name" class="font-size-10" :reduce="district => district.subdistrict_id" :options="districtList" v-model="kecamatan.value" placeholder="Pilih Kecamatan">
									<template v-slot:no-options="{ search, searching }">
										<template v-if="searching">
											Tidak ada kata yang cocok untuk <em>{{ search }}</em>.
										</template>
										<em style="opacity: 0.5;" v-else>Ketik untuk mencari Kecamatan</em>
									</template>
								</v-select>
							</div>
							<div class="col-12 col-lg-1 pt-2 pt-lg-0 pr-lg-0">
								<button class="col-12 btn btn-sm rounded background-button-template color-white box-purple" @click="cari()">
									<span class="d-none d-lg-block" v-if="false"><i class="fas fa-search mr-2"></i></span>
									<span class="font-size-12 font-size-sm-11">Cari</span>
								</button>
							</div>
						</div>
					</div>
					<div class="col-12 p-0 pb-4">
						<div class="container p-0">
							<div class="row" v-show="allStockist.length == 0">
								<SkeletonStockist class="col-6 col-md-4 col-lg-3 mt-md-4 mt-3 pl-2 pr-2 pl-md-3 pr-md-3" v-for="n in 8" :key="'sekeleton'+n"/>
							</div>
							<div class="row" v-if="allStockist == 'error'">
								<div class="col-12 mt-md-4 mt-3 text-center">
									<div class="col-12 pb-2 background-white rounded cus-box-shadow">
										<div class="col-12 p-0 d-flex justify-content-center pb-2">
											<div class="col-9 col-md-4 mt-1 pt-4 text-center">
												<img src="assets/icon/mobile_counter_notfound.svg" class="img-fluid">
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="row" v-else>
								<div class="col-12 pr-0 d-flex flex-wrap">
									<div class="col-6 col-md-4 col-lg-3 mt-md-4 mt-3 pl-0" :class="stockist.stockist_close_status == 'close'? 'close-stockist' :''" v-for="(stockist, index) in allStockist" :key="index">
										<div class="col-12 pl-0 pr-0 output-search rounded">
											<div class="output-search-hover position-absolute rounded pt-2">
												<div class="col-12 text-center font-size-15 color-mila font-weight-bold pt-2 pt-md-3 font-size-sm-13">
													<b><span id="kota">{{stockist.stockist_origin_city_name}}</span></b>
												</div>
												<div class="col-12 text-center font-size-14 color-mila font-size-sm-11">
													<span id="provinsi">{{stockist.stockist_origin_province_name}}</span>
												</div>
												<div class="col-12 p-0">
													<div class="row">
														<div class="col-12 pt-2 pb-2">
															<div class="col-12 text-center bg-white rounded p-0">
																<div class="col-12 pt-3 pb-3 d-none justify-content-center">
																	<font-awesome-icon :icon="['fas', 'star']" class="ml-1 mr-1 color-star-full"/>
																	<font-awesome-icon :icon="['fas', 'star']" class="ml-1 mr-1 color-star-full"/>
																	<font-awesome-icon :icon="['fas', 'star']" class="ml-1 mr-1 color-star-full"/>
																	<font-awesome-icon :icon="['fas', 'star']" class="ml-1 mr-1 color-star-full"/>
																	<font-awesome-icon :icon="['fas', 'star']" class="ml-1 mr-1 color-star-empty"/>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div class="col-12 p-0 text-center">
													<router-link :to="{ name: 'stockist' , params: { code: stockist.stockist_code }}" class="col-10 col-md-8 btn background-button-template rounded font-size-sm-7 color-white box-purple">
														<font-awesome-icon :icon="['fas', 'shopping-cart']" class="mr-2"/>Beli Produk
													</router-link>
												</div>
											</div>
											<div class="col-12 p-0 border output-search-nohover rounded cus-box-shadow">
												<div class="col-12 p-3 p-md-4 text-center">
													<img class="img-fluid img-thumb-stockist ma-md-height-220 height-sm-130 rounded" :src="stockist.stockist_image" alt="stockist">
													<span v-if="parseInt(stockist.stockist_distance_km.replace('.','')) < 999999" class="badge-location color-black font-size-12 font-size-sm-9 f-lato">{{stockist.stockist_distance_km}} km</span>
												</div>
												<div class="col-12 text-center color-mila font-size-13 font-size-sm-10 mt-n1 f-lato">
													<b><span id="idMember">{{stockist.stockist_code}}</span></b>
												</div>
												<div class="col-12 text-center font-size-13 font-size-sm-9 pb-2">
													<div id="idStockis" class="stockist-name font-weight-bold">{{stockist.stockist_name}}</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						
						<!-- <div class="container mt-4 text-center">
							<div class="row">
								<div class="col-12 pb-2 background-white rounded cus-box-shadow">
									<div class="col-12 p-0 d-flex pb-2 pl-4">
										<div class="col-12 p-0">
											<div class="row">
												<div class="offset-md-4 col-md-4 offset-1 col-10 mt-1 pt-4 text-center">
													<img src="assets/icon/mobile_counter_notfound.svg" class="img-fluid">
												</div>
												<div class="col-12">
													<p class="font-size-sm-10 font-size-12 mt-4 mb-2">Mobile Counter di Provinsi <b></b> tidak tersedia</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div> -->
					</div>
					<div class="col-12 text-center pb-4 pt-2" v-if="pagination.next > 0">
						<a href="javascript:;" class="btn background-button-template box-purple" @click="tampilbanyak">
							<div class="text-capitalize color-white font-size-10">
								<i class="fas fa-sync mr-2"></i>
								<span class="">Muat lebih banyak</span>
							</div>
						</a>
					</div>
					<ml-partner-us></ml-partner-us>
				</div>
			</div>
		</div>
		<VModal ref="modalManfaat" >
			<template v-slot:header>
				<div class="modal-header">
					<h5 class="modal-title">Manfaat Milagros</h5>
					<!-- <button class="btn btn-no-box"> <img src="../../assets/modal_x.svg" class="close-modal ml-2" @click="modalHide"> </button> -->
				</div>
			</template>

			<template v-slot:body>
				<ul class="col-12 p-0 nav nav-tabs nav-scroll no-border pt-3" id="myTab" role="tablist">
					<li class="nav-item col-9 col-md-4 p-0 text-center font-size-sm-10">
						<a class="nav-link color-black no-border-radius active" id="home-tab" data-toggle="tab" href="#komponen" role="tab" aria-controls="home" aria-selected="true">Air Komponen Utama Tubuh</a>
					</li>
					<li class="nav-item col-4 col-md p-0 text-center font-size-sm-10">
						<a class="nav-link color-black no-border-radius" id="profile-tab" data-toggle="tab" href="#kandungan" role="tab" aria-controls="profile" aria-selected="false">Kandungan</a>
					</li>
					<li class="nav-item col-4 col-md p-0 text-center font-size-sm-10">
						<a class="nav-link color-black no-border-radius" id="contact-tab" data-toggle="tab" href="#kebutuhan" role="tab" aria-controls="contact" aria-selected="false">Kebutuhan</a>
					</li>
					<li class="nav-item col-4 col-md p-0 text-center font-size-sm-10">
						<a class="nav-link color-black no-border-radius" id="contact-tab" data-toggle="tab" href="#fungsi" role="tab" aria-controls="contact" aria-selected="false">Fungsi</a>
					</li>
				</ul>
				<div class="tab-content" id="myTabContent">
					<div class="tab-pane fade show active" id="komponen" role="tabpanel" aria-labelledby="komponen-tab">
						<div class="d-md-flex pt-3 pb-3">
							<div class="col-6 offset-3 col-md-4 offset-md-0 text-center"><img src="assets/icon/ilus_air_komponen.svg" class="img-fluid"></div>
							<div class="col-12 col-md-8 pt-4 font-size-sm-10 pr-0 pl-0 pr-md-3 pl-md-3 color-black">Air merupakan komponen utama dalam sel tubuh, yaitu sebanyak 60-70 persen. Beberapa organ tubuh yang mengandung air  seperti paru- paru sebesar 90 persen, 82 persen pada darah, 80 persen pada kulit dan 70 persen pada otak.</div>
						</div>
					</div>
					<div class="tab-pane fade" id="kandungan" role="tabpanel" aria-labelledby="kandungan-tab">
						<div class="d-md-flex pt-3 pb-3">
							<div class="col-6 offset-3 col-md-4 offset-md-0 text-center"><img src="assets/icon/ilus_kandungan.svg" class="img-fluid"></div>
							<div class="col-12 col-md-8 pt-3 font-size-sm-10 pr-0 pl-0 pr-md-3 pl-md-3 color-black">Kandungan air dalam tubuh manusia bervariasi di setiap kondisi. Pada saat embrio, hampir 98 persen kandungan tubuh adalah air. Ketika bertumbuh menjadi bayi kandungan air menjadi 80 persen, 60 persen pada saat dewasa dan 50 persen ketika memasuki usia lanjut atau di atas 65 tahun.</div>
						</div>
					</div>
					<div class="tab-pane fade" id="kebutuhan" role="tabpanel" aria-labelledby="kebutuhan-tab">
						<div class="d-md-flex pt-3 pb-3">
							<div class="col-6 offset-3 col-md-4 offset-md-0 text-center pt-4"><img src="assets/icon/ilus_kebutuhan.svg" class="img-fluid"></div>
							<div class="col-12 col-md-8 pt-3 pt-md-2 pr-0 pl-0 pr-md-3 pl-md-3">
								<div class="col-12 pr-0 pl-0 pr-md-3 pl-md-3">
									<div class="font-size-sm-10 color-black">Kebutuhan asupan air putih setiap orang berbeda-beda. Hal ini ditentukan oleh beberapa faktor seperti aktivitas, iklim, pakaian yang dikenakan, usia, kondisi sehat atau sakit serta faktor menyusui dan ibu hamil.</div>
								</div>
								<div class="col-12 pt-3 pr-0 pl-0 pr-md-3 pl-md-3">
									<div class="font-size-sm-10 color-black">Pada umumnya orang dewasa dengan aktivitas ringan yang bekerja di kantor berpenyejuk ruangan membutuhkan asupan cairan sebanyak 2,5 liter per hari. Dimana sekitar 2 liter didapatkan dari air putih yang diminum. Ada pula pendapat lain yang menyandarkan bahwa  jumlah kebutuhan ideal air minum per hari berdasarkan satuan berat badan sebanyak  0,0284 x berat badan.</div>
								</div>
							</div>
						</div>
					</div>
					<div class="tab-pane fade" id="fungsi" role="tabpanel" aria-labelledby="fungsi-tab">
						<div class="d-md-flex pt-3 pb-3">
							<div class="col-6 offset-3 col-md-4 offset-md-0 text-center pt-3"><img src="assets/icon/ilus_fungsi.svg" class="img-fluid"></div>
							<div class="col-12 col-md-8 pt-3 pt-md-2 pr-0 pl-0 pr-md-3 pl-md-3 color-black">
								<div class="col-12 font-size-sm-10 pr-0 pl-0 pr-md-3 pl-md-3">Beberapa literatur menyebutkan bahwa pemenuhan kebutuhan air dalam tubuh dapat mencegah timbulnya berbagai gangguan kesehatan serta membuat tubuh lebih bugar. Beberapa fungsi air seperti :</div>
								<div class="col-12 pt-2 font-size-sm-10 pr-0 pl-0 pr-md-3 pl-md-3">- Menjaga suhu tubuh</div>
								<div class="col-12 font-size-sm-10 pr-0 pl-0 pr-md-3 pl-md-3">- Memperlancar pencernaan</div>
								<div class="col-12 font-size-sm-10 pr-0 pl-0 pr-md-3 pl-md-3">- Media transportasi zat gizi dan oksigen lewat peredaran darah</div>
								<div class="col-12 font-size-sm-10 pr-0 pl-0 pr-md-3 pl-md-3">- Membantu sistem metabolisme tubuh</div>
								<div class="col-12 font-size-sm-10 pr-0 pl-0 pr-md-3 pl-md-3">- Memelihara kulit</div>
								<div class="col-12 font-size-sm-10 pr-0 pl-0 pr-md-3 pl-md-3">- Pelumas sendi</div>
							</div>
						</div>
					</div>
				</div>
			</template>

			<template v-slot:footer>
				<div class="modal-footer">
					<button class="btn btn-outline-danger text-capitalize" @click="modalHide"><font-awesome-icon :icon="['fas', 'times']" class="mr-2"/>Tutup</button>
				</div>
			</template>
		</VModal>
	</div>
</template>

<script>
import carousel from 'vue-owl-carousel';
import vSelect from "vue-select";
import MlPartnerUs from '@/components/MlPartnerUs.vue';
import VModal from '@/components/VModal';
import SkeletonStockist from '@/components/Skeleton/SkeletonStockist';
import SkeletonProduct from '@/components/Skeleton/SkeletonProduct';
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
	name: 'home',
	components: {
		MlPartnerUs, VModal, carousel, vSelect, SkeletonStockist, SkeletonProduct
	},
	data () {
		return {
			kode:{
				value:'',
				comparison:'=',
				type:'string',
				field:'stockist_code'
			},
			provinsi:{
				value:'',
				comparison:'=',
				type:'string',
				field:'stockist_origin_province_id'
			},
			kota:{
				value:'',
				comparison:'=',
				type:'string',
				field:'stockist_origin_city_id'
			},
			kecamatan:{
				value:'',
				comparison:'=',
				type:'string',
				field:'stockist_origin_subdistrict_id'
			},
			params:[],
			currentPage:1,
			total_page:0,
			readyToLoad: true,
			page:1,
		}
	},
	// props: {
	// 	provinces: {
	// 		type: Array
	// 	},
	// },
	computed : {
		...mapState('product', ['allProduct']),
		...mapState('stockist', ['allStockist', 'provinces', 'cities', 'subdistricts', 'pagination']),
		...mapState('maps', ['location']),

		provinceList() {
			let prov = [...this.provinces]
			let allProv = {
				province: "Semua Provinsi",
				province_id: ""
			}
			prov.unshift(allProv)
			return prov
		},
		cityList() {
			let city = [...this.cities]
			let allCity = {
				city_id: "",
				city_name: "Semua Kota",
				type: "",
				city_type_name: "Semua Kota"
			}
			city.unshift(allCity)
			return city
		},
		districtList() {
			let district = [...this.subdistricts]
			let allCity = {
				subdistrict_id: "",
				subdistrict_name: "Semua Kecamatan"
			}
			district.unshift(allCity)
			return district
		}
	},
	methods: {
		...mapActions('product', ['getAllProduct']),
		...mapActions('stockist', ['getAllStockist', 'getStockistByProvince', 'getCity', 'getSubdisctrict', 'search', 'getMoreAllStockist']),
		...mapMutations('stockist', ['reset']),

		async searchCity(val) {
			this.kota.value = await ''
			this.kecamatan.value = await ''
			if (val) {
				await this.getCity({
					province_id: val
				})
			}
		},
		async searchDistrict(val) {
			this.kecamatan.value = await ''
			if (val) {
				await this.getSubdisctrict({
					city_id: val
				})
			}
		},
		lihatManfaat() {
			this.$refs.modalManfaat.modalShow()
		},
		modalHide() {
			this.$refs.modalManfaat.modalHide()
		},
		cari() {
			this.params = []
			if(this.provinsi.value) {
				this.params.push(this.provinsi)
			}
			if(this.kota.value) {
				this.params.push(this.kota)
			}
			if(this.kecamatan.value) {
				this.params.push(this.kecamatan)
			}
			if(this.kode.value) {
				this.params.push(this.kode)
			}
			this.search({
				filter: this.params,
				lat: this.location.lat,
				lng: this.location.lng
			})
		},
		tampilbanyak() {
			this.page++;
			this.getMoreAllStockist({'page': this.page,
				limit: 12,
				filter: this.params,
				lat: this.location.lat,
				lng: this.location.lng
			});
		}
	},
	created: function () {
		this.$store.dispatch('setPageTitle', 'Beranda');
		this.getAllProduct();
		this.getStockistByProvince();
		this.getAllStockist({
			'limit':12,
			'lat': this.location.lat,
			'lng': this.location.lng
		});
	},
	watch: {
		location: {
			deep: true,
			handler: function(val , old) {
				if (val.lat != old.lat) {
					this.getAllStockist({
						'limit':12,
						'lat': this.location.lat,
						'lng': this.location.lng
					});
				}
			}
		}
	},
	beforeDestroy() {
		this.reset();
		window.removeEventListener('scroll', this.handleScroll);
	},
	filters: {
		truncate: function (text, length, suffix) {
			return text.substring(0, length) + suffix;
		},
	}
}
</script>

<style>
.box-product {
	min-height: 10.5rem;
}
.nav-tabs .nav-link.active {
	background-image: linear-gradient(to right, #7C1CC6, #460C94) !important;
	border: none;
	color: #fff !important;
}
.no-border-radius {
	border-radius: unset !important;
}
.btn-no-box:focus {
	border: none !important;
	box-shadow: none !important;
}
.stockist-name {
	min-height: 52px;
	overflow: hidden;
	max-height: 52px;
}
/* .owl-carousel .owl-stage-outer {
	width: calc(100% + 10px);
} */

@media (min-width: 100px) and (max-width: 767px) {
	.nav-scroll {
		overflow-y: hidden;
		overflow-x: scroll;
		flex-wrap: nowrap
	}
}
@media (max-width: 768px) {
	.col-6.col-md-3.mt-3.mt-md-4:nth-child(even) {
		padding-left: 0.25rem !important;
	}
	.col-6.col-md-3.mt-3.mt-md-4:nth-child(odd) {
		padding-right: 0.25rem !important;
	}
}
</style>